import React, { useState, useEffect, useRef } from "react";
import {
  CalendarMonth,
  ReceiptLong,
  ImportContacts,
  Receipt,
  EditOutlined,
  Description,
} from "@mui/icons-material";
import { Box, Button, Card, Grid, Tab, Tabs, Toolbar } from "@mui/material";
import { PatientsContext, PatientsProvider } from "../../../stores/Patients/patients.provider";
import PatientPage from "../../PatientDataEntryForm/PatientPage";
import { useMasterTables } from "../../../stores/MasterTables";
import useStore from "../../../helpers/useStore";
import RxOverView from "../../PatientOverview/RxInfo/RxOverView";
import RxPage from "./../../RxPage";
import { observer } from "mobx-react";
import ScheduleOverview from "./../../ScheduleOverview/ScheduleOverview";
import SimpleDocumentViewer from "../../Documents/SimpleDocumentViewer";
import { PatientDto } from "../../../api-client";
import { RxStoreProvider } from "../../../stores/Rx/rx.provider";
import { DoctorProvider } from "../../../stores/Doctor/doctor.provider";
import { AppointmentProvider } from "../../../stores/Appointment/appointment.provider";
import { NotesProvider } from "../../../stores/Notes/notes.provider";
import { usePatient } from "../../../stores/Patients/patient.queries";

interface PatientControlsProps {
  patientId: number;
  selectedRxId: string;
  rxNumber: string;
}

const PatientControls = observer(({ patientId, selectedRxId, rxNumber }: PatientControlsProps) => {
  const [state, setState] = useState({
    value: 0,
    tab: "new-person",
  });

  const { data: patientData, isLoading: isPatientLoading, refetch: refetchPatient } = usePatient(patientId);

  const [selectedSubTab, setSelectedSubTab] = useState<number>(1);
  const [openDocumentViewer, setOpenDocumentViewer] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any | null>({
    id: selectedRxId,
    rxNumber: rxNumber,
  });
  const [patient, setPatientData] = useState<PatientDto | null>(null);
  const { data: masterTablesData } = useMasterTables();
  // console.log("masterinrx", masterTablesData);

  const fetchData = async (_patient?: any) => {
    await refetchPatient();
  };

  // use effect to fetch data when loading component
  useEffect(() => {
    if (patientData && !isPatientLoading) {
      const formattedValues = {
        ...patientData,
        payer: patientData.payer,
        smsDesired: patientData?.smsDesired,
        rxs: patientData.rxs?.filter((rx: any) => rx.deletedAt == null),
      };
      setPatientData(formattedValues);
    }
  }, [patientData, isPatientLoading]);

  const updatePatientData = (updatedData: any) => {
    setPatientData(updatedData);
  };

  const [patientSubTabs, setPatientSubTabs] = useState<Array<any>>([]);

  const openPatientSubTab = (
    patientIndex: number,
    rowData: any // Pass additional data from handleRowClick
  ) => {
    setPatientSubTabs((prevTabs) => {
      const updatedSubTabs = [...prevTabs];
      if (!updatedSubTabs[patientIndex]) {
        updatedSubTabs[patientIndex] = [];
      }

      // Check if a sub-tab already exists for the patient
      if (updatedSubTabs[patientIndex].length === 0) {
        updatedSubTabs[patientIndex].push(rowData);
      } else {
        // If a sub-tab already exists, update its content with the received data
        updatedSubTabs[patientIndex][0] = rowData;
      }

      return updatedSubTabs;
    });
  };

  // Function to handle row click in the "Rx Overview" table

  const handleRowClick = (data: any) => {
    // console.log("row was clicked", data);
    setSelectedSubTab(3); // Set the selected sub-tab to "Rx Overview"
    setSelectedRow(data);
  };

  const handleSubTabChange = (event: any, newValue: number) => {
    setSelectedSubTab(newValue);
  };

  return patient ? (
    <RxStoreProvider>
      <DoctorProvider>
        <AppointmentProvider>
          <NotesProvider>
            <Grid container spacing={0} sx={{ marginTop: "20px !important" }}>
              <Grid item xs={9} sm={9}>
                <Card sx={{ border: "2px splid #ccc", minHeight: "100vh", maxWidth: "100%" }}>
                  <Tabs
                    orientation="horizontal" // Display tabs vertically
                    value={selectedSubTab}
                    onChange={handleSubTabChange}
                    aria-label="sub-tabs"
                  >
                    <Tab
                      iconPosition="start"
                      label={
                        <span
                          style={{
                            color: "black",
                            fontWeight: selectedSubTab === 1 ? "bold" : "normal",
                            fontSize: "12px",
                          }}
                        >
                          Rezepte
                        </span>
                      }
                      // component={Link}
                      // to={onSubTabClick(patientData[index].id,1)}

                      icon={
                        <ImportContacts
                          sx={{
                            fontWeight: selectedSubTab === 1 ? "bold" : "normal",
                          }}
                        />
                      }
                      value={1}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        // backgroundColor:
                        //   selectedSubTab === 0 ? "primary.light" : "secondary.dark",
                        borderBottom: "2px solid secondary.dark",
                        borderRadius: "10px",
                        // borderTopLeftRadius: "10px", // Apply border radius to top-left corner
                        // borderBottomLeftRadius: "10px", // Apply border radius to top-right corner
                        margin: "6px",
                      }}
                    />
                    <Tab
                      label="Termine"
                      // component={Link}
                      // to={onSubTabClick(patientData[index].id,2)}
                      icon={
                        <CalendarMonth
                          sx={{
                            fontWeight: selectedSubTab === 2 ? "bold" : "normal",
                          }}
                        />
                      }
                      value={2}
                      sx={{
                        // backgroundColor:
                        //   selectedSubTab === 2 ? "secondary.light" : "secondary.dark",
                        // borderBottom: "2px solid #7c4dff",
                        // borderTopLeftRadius: "10px", // Apply border radius to top-left corner
                        // borderTopRightRadius: "10px", // Apply border radius to top-right corner
                        margin: "6px",
                      }}
                    />
                    <Tab
                      label="Rechnungen"
                      // component={Link}
                      // to={onSubTabClick(patientData[index].id,3)}
                      icon={
                        <CalendarMonth
                          sx={{
                            fontWeight: selectedSubTab === 3 ? "bold" : "normal",
                          }}
                        />
                      }
                      value={3}
                      sx={{
                        // backgroundColor:
                        //   selectedSubTab === 2 ? "secondary.light" : "secondary.dark",
                        // borderBottom: "2px solid #7c4dff",
                        // borderTopLeftRadius: "10px", // Apply border radius to top-left corner
                        // borderTopRightRadius: "10px", // Apply border radius to top-right corner
                        margin: "6px",
                      }}
                    />
                    <Tab
                      label="e-Akte"
                      // component={Link}
                      // to={onSubTabClick(patientData[index].id,4)}
                      icon={
                        <Description
                          sx={{
                            fontWeight: selectedSubTab === 4 ? "bold" : "normal",
                          }}
                        />
                      }
                      value={4}
                      sx={{
                        // backgroundColor:
                        //   selectedSubTab === 4 ? "secondary.light" : "secondary.dark",
                        // borderBottom: "2px solid #7c4dff",
                        // borderTopLeftRadius: "10px", // Apply border radius to top-left corner
                        // borderTopRightRadius: "10px", // Apply border radius to top-right corner
                        margin: "6px",
                      }}
                    />

                    <Grid></Grid>
                  </Tabs>
                  {(() => {
                    switch (selectedSubTab) {
                      case 1:
                        // console.log("ABCe", patient);
                        return (
                          <RxOverView
                            openPatientTab={(row: any) => handleRowClick(row)}
                            setPatientData={setPatientData}
                            handleData={fetchData}
                            masterData={masterTablesData || []}
                            noNavigate
                          />
                        );

                      case 2:
                        return (
                          <ScheduleOverview/>
                        );

                      case 3:
                        return;

                      case 4:
                        return (
                          <Box sx={{ p: 2 }}>
                            <Button
                              variant="contained"
                              startIcon={<Description />}
                              onClick={() => setOpenDocumentViewer(true)}
                              sx={{ mb: 2 }}
                            >
                              Dokumente anzeigen
                            </Button>
                            <SimpleDocumentViewer
                              open={openDocumentViewer}
                              onClose={() => setOpenDocumentViewer(false)}
                              patientId={patient?.id}
                            />
                          </Box>
                        );

                      // case 4:
                      //   console.log("ABCe", patient,index,patientData,patientData[index]);
                      //   return (
                      //     <RxOverView
                      //      patientData={patientData[index]}
                      //       openPatientTab={(row: any) => handleRowClick(row)}
                      //       setPatientData={(row: any) =>
                      //         setPatientsData(row)
                      //       }
                      //       handleData={fetchData}
                      //     />
                      //   );
                    }
                  })()}
                </Card>
              </Grid>
            </Grid>
          </NotesProvider>
        </AppointmentProvider>
      </DoctorProvider>
    </RxStoreProvider>
  ) : (
    <div>Loading...</div>
  );
});

export default PatientControls;
